import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'getFaceIcon'
})
export class GetFaceIconPipe implements PipeTransform {
  transform(rating: number): string {
    switch (rating) {
      case 1:
        return 'far fa-angry';
      case 2:
        return 'far fa-frown';
      case 3:
        return 'far fa-smile';
      case 4:
        return 'far fa-grin-stars';
      default:
        return '';
    }
  }
}
